var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"refresh--button",on:{"click":_vm.reload}},[_c('span',[_vm._v("Lataa")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }